import axios from 'axios'

import { getToken, removeToken } from 'utils/cookies'
import { disconnectSocket } from 'lib/socket'

const adminApiUrl = `${process.env.REACT_APP_API_BASE_URL}/api/v1/admin`

export const axiosInterceptorInstance = axios.create({
  baseURL: adminApiUrl,
})

axiosInterceptorInstance.interceptors.request.use(
  (config) => {
    const accessToken = getToken()
    if (accessToken) {
      if (config.headers) config.headers.Authorization = `Bearer ${accessToken}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

axiosInterceptorInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    const { response } = error

    if (response) {
      const { status } = response

      if (status === 401) {
        logoutUser()
      }
    }

    return Promise.reject(error)
  },
)

const logoutUser = () => {
  disconnectSocket()
  removeToken()
  window.location.reload()
}

export default axiosInterceptorInstance
